import { ApiFail } from './ApiFail';

export class ResponseSchemaInvalidFail extends ApiFail {}
